import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _MemoCategory;

import { MemoCategoryKey } from 'src/types';
export var MemoContentType;

(function (MemoContentType) {
  MemoContentType["json"] = "json";
  MemoContentType["text"] = "text";
})(MemoContentType || (MemoContentType = {}));

export var MemoCategory = (_MemoCategory = {}, _defineProperty(_MemoCategory, MemoCategoryKey.booking_note, {
  title: '預約電訪註記',
  contentType: MemoContentType.text
}), _defineProperty(_MemoCategory, MemoCategoryKey.return_appointment_info_handover, {
  title: '客戶回診交接',
  contentType: MemoContentType.text
}), _defineProperty(_MemoCategory, MemoCategoryKey.client_info_detail, {
  title: '客戶細節備註',
  contentType: MemoContentType.text
}), _defineProperty(_MemoCategory, MemoCategoryKey.feedback_from_satisfactory_survey, {
  title: '滿意度問卷回饋',
  contentType: MemoContentType.text
}), _defineProperty(_MemoCategory, MemoCategoryKey.personalized_supplement_assistant, {
  title: '客保顧問',
  contentType: MemoContentType.text
}), _defineProperty(_MemoCategory, MemoCategoryKey.one_on_one_consultation, {
  title: '分析總結回報',
  contentType: MemoContentType.json
}), _defineProperty(_MemoCategory, MemoCategoryKey.personalized_supplement_consultation, {
  title: '客保總結回報',
  contentType: MemoContentType.json
}), _MemoCategory);
export var ClientMemoTemplate = _defineProperty({}, MemoCategoryKey.return_appointment_info_handover, 'templates/memo:return_appointment_info_handover');